import { IPackage } from '../graphQL/commons'
import { IConfig, IPackageProduct } from '../interfaces'
import formatPrice, { stripHiddenPrice } from './formatPrice'

export const sanitizeExtraPackages = (
  source: IPackage[],
  config?: IConfig,
): IPackageProduct[] => {
  return source.map((packageSource) => {
    const currency: string | undefined =
      config?.options?.currency || config?.options?.currencySymbol
    const format: string | undefined = config?.options?.format
    return {
      ...packageSource,
      suffix: stripHiddenPrice(
        formatPrice({
          currency,
          format,
          price: packageSource.price,
          hidePrices: config?.options?.hidePricesActive,
        }),
      ),
    }
  })
}
